import { diffLines } from "@/lib/packFiles";
import { cn } from "@/lib/cn";

/** Line diff of the original file against the text in the editor. */
export function DiffView({
  original,
  current,
}: {
  original: string;
  current: string;
}) {
  const lines = diffLines(original, current);
  if (lines.every((line) => line.kind === "same")) {
    return <p className="text-sm text-muted-foreground">No changes.</p>;
  }
  return (
    <div
      aria-label="Changes"
      className="max-h-80 overflow-auto rounded-md border border-border font-mono text-xs"
    >
      {lines.map((line, index) => (
        <div
          key={index}
          data-diff={line.kind}
          dir="auto"
          style={{ unicodeBidi: "plaintext" }}
          className={cn(
            "whitespace-pre px-2 leading-5",
            line.kind === "removed" && "bg-destructive/10 text-destructive",
            line.kind === "added" && "bg-success/20 text-foreground",
          )}
        >
          {line.kind === "removed" ? "- " : line.kind === "added" ? "+ " : "  "}
          {line.text}
        </div>
      ))}
    </div>
  );
}
